module.exports = __webpack_public_path__ + "img/sv13.22dbeaf3.svg";